function loadMoreReferences() {
    const pageURL = $(location).attr("href");
    const fireSpace = 200;

    let page = 1;
    let position = $(window).scrollTop();

    $(window).on("scroll", function() {
        let scroll = $(window).scrollTop();

        if ( scroll > position && $(".news-grid-container").length > 0 ) {

            if ( scroll + $(window).height() + fireSpace > $(".page-news-item").last().offset().top && !$(".news-grid-container").hasClass("loading") ) {
                
                $(".news-grid-container").addClass("loading");
                page++;

                $.ajax({
                    url:    pageURL+'page/'+page,
                    type:   'POST',
                    success: function() {
                        
                        $.ajax({ 
                            url: pageURL+'page/'+page 
                        }).done( function(html) {
                            
                            let newItem = $(html).find('.page-news-item');
                            newItem.appendTo(".news-grid-container");

                            if ( newItem.length > 5 ) {
                                $(".news-grid-container").removeClass("loading");
                            }

                        });

                    }
                });

            }

        }

        position = scroll;
    });
}


$(document).ready( function() {
    loadMoreReferences();
});